import { render, staticRenderFns } from "./SearchWinemag.vue?vue&type=template&id=11cfa404&scoped=true"
import script from "./SearchWinemag.vue?vue&type=script&lang=js"
export * from "./SearchWinemag.vue?vue&type=script&lang=js"
import style0 from "./SearchWinemag.vue?vue&type=style&index=0&id=11cfa404&prod&lang=scss&scoped=true"
import style1 from "./SearchWinemag.vue?vue&type=style&index=1&id=11cfa404&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11cfa404",
  null
  
)

export default component.exports